// extracted by mini-css-extract-plugin
export default {"container":"style_container__opjp6","controls":"style_controls__VcRrO","checkbox":"style_checkbox__xCYJs","button":"style_button__O0K3O","selector":"style_selector__bXoZC"};